const MAX_AND_EXPRESSIONS = 8;
const MAX_OR_EXPRESSIONS = 3;
const COMPARISON_OPERATOR = 'NumberGreaterOrEqualTo';

const addError = (errors, code, message, path) => {
  errors.push({ code, message, path });
};

const validateAttributeCondition = (condition, path, errors) => {
  if (!condition || typeof condition !== 'object') {
    addError(errors, 'INVALID_ATTRIBUTE_CONDITION', 'AttributeCondition must be an object.', path);
    return;
  }
  if (!condition.Name || !condition.Value) {
    addError(errors, 'INVALID_ATTRIBUTE_CONDITION', 'AttributeCondition requires Name and Value.', path);
  }
  if (!Number.isInteger(condition.ProficiencyLevel) || condition.ProficiencyLevel < 1 || condition.ProficiencyLevel > 5) {
    addError(errors, 'INVALID_PROFICIENCY', 'ProficiencyLevel must be an integer from 1 through 5.', `${path}.ProficiencyLevel`);
  }
  if (condition.ComparisonOperator !== COMPARISON_OPERATOR) {
    addError(errors, 'INVALID_COMPARISON_OPERATOR', `ComparisonOperator must be '${COMPARISON_OPERATOR}'.`, `${path}.ComparisonOperator`);
  }
};

const validateExpression = (expression, path, errors, topLevel = true) => {
  if (!expression || typeof expression !== 'object' || Array.isArray(expression)) {
    addError(errors, 'INVALID_EXPRESSION', 'Expression must be an object.', path);
    return;
  }

  const expressionKeys = ['AttributeCondition', 'AndExpression', 'OrExpression']
    .filter((key) => expression[key] !== undefined);
  if (expressionKeys.length !== 1) {
    addError(errors, 'INVALID_EXPRESSION', 'Expression must contain exactly one supported expression type.', path);
    return;
  }

  const expressionType = expressionKeys[0];
  if (expressionType === 'AttributeCondition') {
    validateAttributeCondition(expression.AttributeCondition, `${path}.AttributeCondition`, errors);
    return;
  }

  const children = expression[expressionType];
  const maximum = expressionType === 'AndExpression' ? MAX_AND_EXPRESSIONS : MAX_OR_EXPRESSIONS;
  if (!Array.isArray(children) || children.length === 0 || children.length > maximum) {
    addError(errors, `INVALID_${expressionType.toUpperCase()}`, `${expressionType} must contain between 1 and ${maximum} expressions.`, `${path}.${expressionType}`);
    return;
  }
  if (expressionType === 'OrExpression' && !topLevel) {
    addError(errors, 'OR_NOT_TOP_LEVEL', 'OrExpression is supported only at the top level.', path);
  }
  children.forEach((child, index) => (
    validateExpression(child, `${path}.${expressionType}[${index}]`, errors, false)
  ));
};

export const validateAwsRoutingCriteria = (compiled) => {
  const errors = [];
  const steps = compiled?.RoutingCriteria?.Steps;
  if (!Array.isArray(steps) || steps.length === 0) {
    addError(errors, 'ROUTING_STEP_REQUIRED', 'RoutingCriteria must contain at least one step.', 'RoutingCriteria.Steps');
    return { valid: false, errors };
  }

  steps.forEach((step, index) => {
    const path = `RoutingCriteria.Steps[${index}]`;
    validateExpression(step?.Expression, `${path}.Expression`, errors);
    if (index < steps.length - 1 && !step?.Expiry) {
      addError(errors, 'EXPIRY_REQUIRED', 'Every step before the final step requires Expiry.', `${path}.Expiry`);
    }
    if (step?.Expiry && (!Number.isInteger(step.Expiry.DurationInSeconds) || step.Expiry.DurationInSeconds <= 0)) {
      addError(errors, 'INVALID_EXPIRY', 'DurationInSeconds must be a positive integer.', `${path}.Expiry.DurationInSeconds`);
    }
  });

  return { valid: errors.length === 0, errors };
};

export default validateAwsRoutingCriteria;